import React, { FC } from 'react';
import styles from './entity_header_components.module.scss';

export const EntityHeaderContainer: FC = ({ children }) => (
  <div className={styles.container}>{children}</div>
);

export const EntityHeaderPicture: FC<{
  imageUrl: string;
}> = ({ imageUrl, children }) => (
  <div
    className={styles.picture}
    style={{
      backgroundImage: `url(${imageUrl})`,
    }}
  >
    {children}
  </div>
);

export const EntityHeaderTitle: FC = ({ children }) => (
  <h1 className={styles.title}>{children}</h1>
);

export const EntityHeaderTitleContainer: FC = ({ children }) => (
  <div className={styles.titleContainer}>{children}</div>
);

export const EntityHeaderInfo: FC = ({ children }) => (
  <span className={styles.info}>{children}</span>
);

export const EntityHeaderImportant: FC = ({ children }) => (
  <span className={styles.important}>{children}</span>
);
